





















































































import { RulesType } from '@tt4b/ttam-enums';
import { computed, defineComponent, PropType } from '@vue/composition-api';

const name = 'ttam-audience-rules';
export default defineComponent({
  name,
  props: {
    errors: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    value: {
      type: Array as PropType<Array<RulesType>>,
      required: true,
    },
    actionsOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    daysOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    minRulesCount: {
      type: Number,
      default: 1,
    },
    maxRulesCount: {
      type: Number,
      default: 5,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const vmRulesData = computed(() => props.value);

    /** User Event */
    const onRemove = (index: number) => {
      emit('remove', { index });
    };

    const onAdd = () => {
      emit('add');
    };

    const onFirstOptionChange = (index: number, rules, newVal: number) => {
      const val = Object.assign({}, rules, {
        code: newVal,
      });
      emit('onChange', {
        index,
        val,
      });
    };

    const onSecondOptionChange = (index: number, rules, newVal: number) => {
      const val = Object.assign({}, rules, {
        days: newVal,
      });
      emit('onChange', {
        index,
        val,
      });
    };

    const isShowEmptyAdd = computed(() => vmRulesData.value.length < 1);
    const isDisabledRemoveBtn = computed(() => vmRulesData.value.length <= props.minRulesCount);
    const isDisabledAddBtnTip = computed(() => vmRulesData.value.length >= props.maxRulesCount);
    const isShowAddBtn = (index: number) => index === vmRulesData.value.length - 1;

    return {
      name,
      vmRulesData,
      isDisabledAddBtnTip,
      isDisabledRemoveBtn,
      isShowEmptyAdd,
      isShowAddBtn,
      onAdd,
      onRemove,
      onFirstOptionChange,
      onSecondOptionChange,
    };
  },
});
